export default class CustomPlayer {
  constructor(videoPlay, video) {
    this.videoPlay = videoPlay;
    this.video = video;

    this.init();
  }

  init() {
    const { videoPlay, video } = this;

    this.playVideo = this.playVideo.bind(this);
    this.clickOutside = this.clickOutside.bind(this);

    // Detect if we have an iframe (YouTube embed) or a <video> element
    this.iframe = null;
    if (video) {
      if (video.tagName === "IFRAME") {
        this.iframe = video;
      } else if (video.querySelector) {
        const found = video.querySelector("iframe");
        if (found) this.iframe = found;
      }
    }
    this.isIframe = !!this.iframe;
    this.originalSrc = this.isIframe
      ? this.iframe.getAttribute("src") || ""
      : null;

    // Attach click listener to the play button/container if provided
    if (videoPlay) videoPlay.addEventListener("click", this.playVideo);
  }

  playVideo(e) {
    e.preventDefault();

    // If it's an iframe (YouTube), toggle autoplay by updating src
    if (this.isIframe) {
      const iframe = this.iframe;
      // Only add autoplay if it's not already present
      if (!/autoplay=1/.test(iframe.getAttribute("src") || "")) {
        const sep = this.originalSrc.indexOf("?") === -1 ? "?" : "&";
        const newSrc = this.originalSrc + sep + "autoplay=1&rel=0&showinfo=0";
        iframe.setAttribute("src", newSrc);
      }
      document.body.classList.add("showVideo");
      setTimeout(
        () => document.addEventListener("click", this.clickOutside),
        1000
      );
      return;
    }

    const { video } = this;
    if (!video) return;
    if (typeof video.play === "function") {
      video.play();
      document.body.classList.add("showVideo");
      setTimeout(
        () => document.addEventListener("click", this.clickOutside),
        1000
      );
    } else {
      console.warn("CustomPlayer: video element has no play() method.");
    }
  }

  stopVideo() {
    // If iframe, restore original src (which stops playback)
    if (this.isIframe) {
      if (this.iframe && this.originalSrc) {
        this.iframe.setAttribute("src", this.originalSrc);
      }
      document.body.classList.remove("showVideo");
      document.removeEventListener("click", this.clickOutside);
      return;
    }

    const { video } = this;

    document.body.classList.remove("showVideo");
    document.removeEventListener("click", this.clickOutside);
    setTimeout(() => {
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.load && video.load();
      }
    }, 500);
  }

  clickOutside(e) {
    const { video } = this;
    const container = video || this.iframe;
    const isClickedInside =
      container && container.contains && container.contains(e.target);

    if (!isClickedInside) this.stopVideo();
  }

  destroy() {
    document.body.classList.remove("showVideo");
    document.removeEventListener("click", this.clickOutside);
    if (this.isIframe && this.iframe && this.originalSrc) {
      this.iframe.setAttribute("src", this.originalSrc);
    }
  }
}
